// @flow
import React from 'react'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'

type Props = {
    theme?: {
        container: string,
    }
}

type State = {
    value: string,
}

/* eslint-disable react/prefer-stateless-function */
class Timeseries extends React.Component<Props, State> {
    static defaultProps = {
        theme: undefined,
    }

    constructor(props) {
        super(props)
        this.state = {
            value: '',
        }
    }

    render() {
        const theme = this.props.theme
        return (
            <div className={theme.geoBarPanel} style={{ height: '100%' }}>
                <h3 className={theme.titleBar}>Timeseries</h3>
                <div className={theme.geoBarPanelScroll}>
                    <div className={theme.geoBarCtr}>
                        <div className={theme.formGroup}>
                            <FormControl fullWidth>
                                <TextField
                                    id="mongo_uri"
                                    defaultValue="mongodb://eds0.engr.colostate.edu:27017/csip_timeseries"
                                    fullWidth
                                    label="Mongodb URI"
                                    margin="normal"
                                />
                            </FormControl>
                        </div>
                        <ul>
                            <li>Create</li>
                            <li>Select</li>
                            <li>Delete</li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default Timeseries
